import numeral from 'numeral';

function formatFootage(footage) {
    const footage_ = parseInt(footage);
    if (isNaN(footage_)) return 'N/A';

    return numeral(footage_).format('0,0');
}

export {
    formatFootage,
};
